import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fundSpecificLookup } from '../../../utilities/preQualServices';

export const fetchFundSpecificLookup = createAsyncThunk(
    'fetchFundSpecificLookup', fundSpecificLookup
)

const initialState = {
    value: [
        {
            LookUpCode: "",
            LookUpValue: "",
            pxObjClass: ""
        }
    ]
}

const fundSpecificLookupSlice = createSlice({
    name: 'fundSpecificLookupSlice',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchFundSpecificLookup.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(fetchFundSpecificLookup.fulfilled, (state, action) => {
                state.value = action?.payload
            })
            .addCase(fetchFundSpecificLookup.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})


export default fundSpecificLookupSlice.reducer